import React from "react";
import Layout from "../components/Layout";
import ProductCard from "../components/ProductCard";
import styles from "./Atlantic.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const oliveProducts = [
  {
    key: "black425",
    image: "/assets/products/vegetables/olives/olive-land-black-pitted-425.jpg",
  },
  {
    key: "black300",
    image: "/assets/products/vegetables/olives/olive-land-black-pitted-300.jpg",
  },
  {
    key: "green300",
    image: "/assets/products/vegetables/olives/olive-land-green-pitted-300.jpg",
  },
];

const Olives = () => {
  const { t } = useLanguage();

  return (
    <Layout>
      <h2 className={styles.heading}>{t("vegetables.olives.title")}</h2>

      <div className={styles.grid}>
        {oliveProducts.map((product) => (
          <ProductCard
            key={product.key}
            title={t(`vegetables.products.olives.${product.key}.title`)}
            weight={t(`vegetables.products.olives.${product.key}.weight`)}
            description={t(`vegetables.products.olives.${product.key}.description`)}
            image={product.image}
          />
        ))}
      </div>
    </Layout>
  );
};

export default Olives;
